
import WDCardList from './wd-card-list';
import WDNavbar from '../navbar/wd-navbar';

export default class WDCardListPager extends WDCardList {

  #pager;
  #pagerCounter;
  #totalCount = 0; 	

	constructor(cfg)
	{
		super(cfg).classList.add('has-pager');
	};

	runFetch()
	{
	  super.runFetch().then( () => {

	    this.#totalCount = this.results().total_count;
	    this.showPager();
	  
	  });
	
	};

  /**
    * @method pagerbar
    */  
  pager()
  {
    if (!this.#pager)
    {
      const pagerBar = new WDNavbar();
      this.footer().append(pagerBar);

      const m = pagerBar.add();
      m.classList.add('wd-pager-counter','d-none','d-md-block','me-auto');
      this.#pagerCounter = m.addText('');
      
      this.#pager = pagerBar.addPager();
      this.#pager.classList.add('me-auto','ms-auto','me-md-0','search-pager');
      this.#pager.on('page:selected',(evt) => this.setOffset(evt.detail.page) );
      
      //make sure we have an offset
      if (this.fetch().limit && !this.fetch().offset) this.fetch().offset = '0';

      //resize the pager when window size changes, or when panes are added and removed
      window.on("resize",(evt) => this.showPager() );
      this.panes().on('pane:added',() => this.showPager() );
      this.panes().on('pane:removed',() => this.showPager() );
    }

    return this.#pager;
  };

  setOffset(idx)
  {
    this.fetch().offset = idx * this.fetch().limit;
    this.runFetch();
  };

  resetOffset()
  {
    this.fetch().offset = 0;
    if (this.#pager) this.#pager.page(0);
  };

  showPager()
  {
    //if (!this.footer()) return;

    let segment = 85;
    let width = this.clientWidth;
    if (width < 768) segment = 80;

    const count = parseInt(width / segment);
    this.pager().load({	count: this.#totalCount,
                        limit: this.fetch().limit,
                        max_pages: count
                     });

    const start = parseInt(this.fetch().offset)+1;
    const end = (parseInt(this.fetch().limit) + parseInt(this.fetch().offset));

    const txt = start + " - " + Math.min(this.#totalCount,end) + " of " + this.#totalCount;
    this.#pagerCounter.text(txt);
    
    this.updateFooter(txt);
  };

  selectPage(idx)
  {
    this.setOffset(idx);
  };

  updateFooter(txt)
  {
    const f = this.list().footer();
    f.content().empty();
    f.add(txt);
  };

};

customElements.define('wd-card-list-pager',WDCardListPager);
